<template>
  <div class="manual-outbound">
    <div v-if="!mode" class="idle-wrap">
      <div class="entry-card" @click="mode = 'scan'">
        <div class="entry-icon scan">
          <van-icon name="scan" size="32" color="#fff" />
        </div>
        <div class="entry-title">扫码出库</div>
        <div class="entry-desc">扫描商家收款码出库</div>
      </div>
      <div class="entry-card" @click="mode = 'select'">
        <div class="entry-icon select">
          <van-icon name="shopping-cart-o" size="32" color="#fff" />
        </div>
        <div class="entry-title">选择商品出库</div>
        <div class="entry-desc">手动选择商品后出库</div>
      </div>
    </div>

    <scan-outbound v-else-if="mode === 'scan'" @back="mode = ''" />
    <select-outbound v-else-if="mode === 'select'" @back="mode = ''" />
  </div>
</template>

<script>
import ScanOutbound from "./scan-outbound.vue";
import SelectOutbound from "./select-outbound.vue";

export default {
  name: "manual-outbound",
  components: {
    ScanOutbound,
    SelectOutbound,
  },
  data() {
    return {
      mode: "", // '' | scan | select
    };
  },
};
</script>

<style scoped lang="less">
.manual-outbound {
  min-height: calc(100vh - 46px);
  background: #f5f6f8;
  box-sizing: border-box;
}

.idle-wrap {
  min-height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.entry-card {
  width: 80%;
  max-width: 320px;
  background: #fff;
  border-radius: 12px;
  padding: 24px 16px;
  margin-bottom: 16px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.entry-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;

  &.scan {
    background: #07c160;
  }
  &.select {
    background: #1989fa;
  }
}

.entry-title {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
}

.entry-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #969799;
}
</style>
